import builder from "./modules/builder"

export default {
    modules: {
        builder
    }
}
